import {parseEventDateTime} from '~/common/utils/time';

const {DateTime} = require('luxon');

const currentDateTime = DateTime.local();
const currentYear = currentDateTime.year;

const dateOptionsWithoutYear: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
};

const dateOptionsWithYear: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
};

const timeOptions: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: '2-digit',
};

const timeOptionsWithTz: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
};

export const formatEventDateForView = (
  date: string,
  timezone: string,
  showYear?: boolean
): string => {
  const dateTime = parseEventDateTime(date, timezone);
  const dateOptions = showYear ? dateOptionsWithYear : dateOptionsWithoutYear;
  return dateTime.toLocaleString(dateOptions);
};

export const formatEventTimeForView = (date: string, timezone: string): string => {
  const dateTime = parseEventDateTime(date, timezone);
  return dateTime.toLocaleString(timeOptionsWithTz);
};

export const formatEventTimespanForView = (
  start: string,
  end: string,
  timezone: string
): string => {
  const startDateTime = parseEventDateTime(start, timezone);
  const endDateTime = parseEventDateTime(end, timezone);
  const startFormatted = startDateTime.toLocaleString(timeOptions);
  const endFormatted = endDateTime.toLocaleString(timeOptionsWithTz);
  return `${startFormatted} - ${endFormatted}`;
};

export const dateInDifferentYear = (date: string): boolean => {
  const dateTime = parseEventDateTime(date);
  return dateTime.year !== currentYear;
};

export const shouldShowYears = (start: string, end: string): boolean => {
  const endDateTime = parseEventDateTime(end);
  if (!endDateTime.isValid) return dateInDifferentYear(start);
  return parseEventDateTime(start).year !== endDateTime.year;
};
